import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareReportViewComponent } from '../compare-report-view.component';

/**
 * Reports tab component
 * Displays the reports panel content for comparison
 * Renders the reportTemplate from the parent component
 */
@Component({
    selector: 'app-compare-reports-tab',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="w-full h-full flex flex-col gap-2 px-3">
            @if (parentComponent && parentComponent.reportTemplateRef) {
                <ng-container *ngTemplateOutlet="parentComponent.reportTemplateRef"></ng-container>
            }
        </div>
    `
})
export class CompareReportsTabComponent implements OnInit {
    @Input() parentComponent?: CompareReportViewComponent;

    ngOnInit() {
        // Component initialized
    }
}

